/**
 * Content editor configuration constants.
 */

export const CONFIG = {
  MAX_HISTORY: 20,
  DEBOUNCE_DELAY: 300,
  PARENT_ORIGIN: '*',
  EDITABLE_ATTR: 'data-musk-text-editable',
  EDITOR_STYLE_ATTR: 'data-musk-editor-style',
  EDITOR_SCRIPT_ATTR: 'data-musk-editor',
  TOOLBAR_ATTR: 'data-musk-toolbar',
  MATHLIVE_CDN: 'https://cdn.jsdelivr.net/npm/mathlive/dist/mathlive.min.mjs',
  GENERAL_HOVER_TAGS: new Set([
    'DIV', 'SECTION', 'ARTICLE', 'ASIDE', 'HEADER', 'FOOTER', 'MAIN', 'NAV',
    'UL', 'OL', 'LI', 'DL', 'DT', 'DD',
    'TABLE', 'THEAD', 'TBODY', 'TR', 'TD', 'TH',
    'FIGURE', 'FIGCAPTION', 'BLOCKQUOTE', 'PRE', 'CODE',
    'FORM', 'FIELDSET', 'DETAILS', 'SUMMARY',
    'CANVAS', 'SVG', 'VIDEO', 'IMG', 'PICTURE',
    'SPAN', 'LABEL', 'A',
  ]),
  FONT_SIZES: [12, 14, 16, 18, 20, 24, 28, 32, 36, 42, 48, 56, 64, 72] as readonly number[],
  COLORS: [
    '#000000', '#333333', '#666666', '#999999', '#CCCCCC', '#FFFFFF',
    '#FF4D4F', '#FF7A45', '#FFA940', '#FFC53D', '#FFEC3D', '#BAE637',
    '#73D13D', '#36CFC9', '#40A9FF', '#597EF7', '#9254DE', '#F759AB',
    '#FFF1F0', '#FFF2E8', '#FFF7E6', '#FFFBE6', '#FCFFE6', '#F6FFED',
    '#E6FFFB', '#E6F7FF', '#F0F5FF', '#F9F0FF', '#FFF0F6', '#E6F7FF',
  ] as readonly string[],
  FEATURES: {
    textEdit: true,
    fontSize: true,
    bold: true,
    italic: true,
    underline: true,
    textColor: true,
    bgColor: false,
    textAlign: true,
    formulaEdit: true,
    aiEdit: true,
  } as const,
  IMAGE_UPLOAD: {
    MAX_SIZE_MB: 20,
    ACCEPT_EXTS: ['.jpeg', '.jpg', '.png', '.webp'] as readonly string[],
    ACCEPT_ATTR: '.jpeg,.jpg,.png,.webp',
  } as const,
} as const

export type FeatureConfig = {
  -readonly [K in keyof typeof CONFIG.FEATURES]: boolean
}

export function createFeatureConfig(): FeatureConfig {
  return { ...CONFIG.FEATURES }
}

export function hasAnyStyleFeature(fc: FeatureConfig): boolean {
  return fc.fontSize || fc.bold || fc.italic || fc.underline
    || fc.textColor || fc.bgColor || fc.textAlign
}
